<template>

      <div class="row mx-0 pt-5 justify-content-center">
        <div class="col-xl-8 col-md-12 col-sm-12 p-4">
          <div class="card">
            <div class="card-body ">
              <h5 class="p-4">Change Password</h5>
              <form class="d-grid" @submit.prevent="doSetupPassword">
                
                <div class="row p-4 ">
                  
                  <div class="col-lg-4 col-md-4 col-sm-5">
                    <llp-label id="password-label" :aria-label="PASSWORD">
                      Password:
                    </llp-label>
                    <llp-input id="password" type="password"> </llp-input>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-5">
                    <llp-label
                      id="confirm-password-label"
                      :aria-label="confirm_password"
                    >
                      Confirm Password:
                    </llp-label>
                    <llp-input id="confirm-password"></llp-input>
                  </div>
                </div>
                <div class="row p-4">
                  <div class="col-auto p-2">
                    <llp-button
                      :loadSpinner="showSpinner"
                      classNames="btn-primary new-btn"
                      type="submit"
                    >
                      Change Password
                    </llp-button>
                  </div>
                  <div class="col-auto p-2">
                    <llp-button
                      :loadSpinner="showSpinner"
                      classNames="btn-primary new-btn"
                      type="submit"
                      @click="goToDashboard"
                    >
                      Back
                    </llp-button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
  
  <llp-toast ref="toast"></llp-toast>
</template>
<script>


export default {
    setup() {
    },
    methods:{
        goToDashboard  ()  {
      this.$router.push( '/dashboard' ); 
        }

    }
}
</script>
